export const overflowMenuButtonTooltip = "ec$t9";
export const notificationsHeaderButton = "fJ8Y3";
export const settingsHeaderButton = "QucxFc";
export const myDayHeaderButton = "r9nXUd";
export const premiumHeaderButton = "EeNaHe";
export default {overflowMenuButtonTooltip,notificationsHeaderButton,settingsHeaderButton,myDayHeaderButton,premiumHeaderButton};